module.exports = __webpack_public_path__ + "img/icon-crowdfunding-orange.a25c3551.svg";